module.exports = __webpack_public_path__ + "img/BCHVHC-logo.b1e90403.png";